import { ListSupportTicketsResponseSchema } from './list-support-tickets.schema';
export const listSupportTicketsContract = {
    method: 'GET',
    path: '/api/v2/support/tickets',
    description: 'List support tickets for the authenticated user',
    responseSchema: ListSupportTicketsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            503: 'Service Unavailable - Zammad not configured or unreachable'
        }
    }
};

//# sourceMappingURL=list-support-tickets.contract.js.map